import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "m-0 d-inline-block" }
const _hoisted_2 = { class: "m-0 d-inline-block" }
const _hoisted_3 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.info)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_font_awesome_icon, { icon: _ctx.icon }, null, 8, ["icon"]),
          _createElementVNode("h5", _hoisted_1, _toDisplayString(_ctx.info), 1)
        ], 64))
      : (_ctx.mobileNumber)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_font_awesome_icon, { icon: _ctx.icon }, null, 8, ["icon"]),
            _createElementVNode("h5", _hoisted_2, [
              _createElementVNode("a", {
                href: 'tel:'+_ctx.mobileNumber
              }, _toDisplayString(_ctx.mobileNumber), 9, _hoisted_3)
            ])
          ], 64))
        : _createCommentVNode("", true)
  ]))
}